
import _ from 'lodash'
import { Enums } from '@/model/util'

function capability (id, action, props) {
  return Enums.value(id, `reco.${id}.title`, Object.assign({ action, inputKey: `reco.${id}.input` }, props))
}

export const RecoCapabilityActionEnum = Enums.create('recoCapability', {
  LICENSE: capability('license', 'searchByLicensePlate', { prop: 'license_plate', country: true }),
  TEXT: capability('search', 'searchByFreeText', { prop: 'search_text' }),
  BROWSE: capability('browse', 'searchByCategory'),
  VIN: capability('vin', 'searchByVin', { prop: 'vin' })
})

export class RecoType {
  constructor (data) {
    Object.assign(this, data)
  }
}

export class RecoCapabilities {
  constructor (data) {
    Object.assign(this, data)
    this.actions = _.filter(RecoCapabilityActionEnum.values, r => _.includes(this.allowed_actions, r.action))
  }

  resolveCountry (user) {
    const country = user && user.country && user.country.toUpperCase()
    return country && _.find(this.allowed_countries, c => country === c.toUpperCase())
  }
}
